import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-covid19',
  templateUrl: './covid19.component.html',
  styleUrls: ['./covid19.component.scss']
})
export class Covid19Component implements OnInit {

  link = 'campaign1';
  languageLabels = {
    en: 'ENGLISH',
    fr: 'FRANÇAIS',
    it: 'ITALIANO',
    es: 'ESPANOL',
    pt: 'PORTUGUÊS'
  };

  constructor(public translate: TranslateService) {
    translate.addLangs(['en', 'fr', 'it', 'es', 'pt']);
    translate.setDefaultLang('en');
    // const browserLang = translate.getBrowserLang();
    // translate.use(browserLang.match(/en|fr/) ? browserLang : "en");
  }

  ngOnInit() {

  }

  buildFreeChatbot(event: Event) {
    const iframe = document.getElementById('nmodes-widget') as HTMLIFrameElement;
    iframe.contentWindow.postMessage({ link: '#campaign1', name: 'open', step: 'Campaign1' }, '*');
  }

  needHelp(event: Event) {
    const iframe = document.getElementById('nmodes-widget') as HTMLIFrameElement;
    iframe.contentWindow.postMessage({ link: '#campaign2', name: 'open', step: 'Campaign2' }, '*');
  }

  wantVolunteer(event: Event) {
    const iframe = document.getElementById('nmodes-widget') as HTMLIFrameElement;
    iframe.contentWindow.postMessage({ link: '#campaign3', name: 'open', step: 'Campaign3' }, '*');
  }

}
